import { Injectable } from "@angular/core";
import { ApiService } from './api.service';
import { TituloUsuarioInterface } from "../models/titulo-usuario.model";
import { PaginateData, PaginateOptions } from "../utils/paginate.utils";
import { Observable, shareReplay } from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class TituloUsuarioService extends ApiService<TituloUsuarioInterface>{
  url = "tituloUsuario";
  getByDni = (paginateOptions: PaginateOptions, dni: number, ignoreCache = false): Observable<PaginateData<TituloUsuarioInterface>> => {
      const params = {};
      const cacheKey = `${JSON.stringify(paginateOptions)}-dni-${dni}-${JSON.stringify(params)}`;
      if (ignoreCache) {
        // Siempre borra el observable anterior si ignoreCache es true
        this._getContent.delete(cacheKey);
      }
      if (!this._getContent.get(cacheKey)) {
        this._getContent.set(cacheKey,
          this.http.get(this.getApiUrl() + '/dni/' + dni, {
            params: {
               ...paginateOptions
            }        }).pipe(shareReplay({ bufferSize: 1, refCount: true }))
        );
      }
      return this._getContent.get(cacheKey)!;
    }
}
